module.exports = __webpack_public_path__ + "static/media/rank2.16a42613.svg";